import { UpdateInformationProps } from "components/BulkUpdateOptionalFieldsModal/types";
import React from "react";
import { useSelector } from "react-redux";
import { selectMasterLabelsBySaleLotId } from "selectors";
import { getIn, useFormikContext } from "formik";
import { getCheckboxFieldName } from "components/BulkUpdateOptionalFieldsModal/util";
import { pluralize } from "lib/pluralize";
import { UpdateInformationWrapper } from "components/BulkUpdateOptionalFieldsModal/UpdateInformationComponents";
import { EMPTY_ARRAY } from "lib";

export function UpdateInformationLabels(
  props: UpdateInformationProps,
): React.JSX.Element | null {
  const { field, modelIds, modelName } = props;
  const { fieldName } = field;

  const { values } = useFormikContext();

  const isSelected = getIn(values, getCheckboxFieldName(fieldName));

  const selectedValues = getIn(values, fieldName) || EMPTY_ARRAY;

  const isRemove = fieldName === "removeLabels";

  const masterLabelIdsBySaleLotIdLookup = useSelector(
    selectMasterLabelsBySaleLotId,
  );

  const matchedLotCount = modelIds.filter(saleLotId =>
    selectedValues.some(masterLabelId =>
      masterLabelIdsBySaleLotIdLookup[saleLotId]?.has(masterLabelId),
    ),
  ).length;

  const pluralizedModelName = pluralize(
    modelName,
    isRemove ? matchedLotCount : modelIds.length,
  );
  const pronoun = selectedValues.length === 1 ? "This" : "These";
  const noun = pluralize("AgriNous Managed label", selectedValues.length);
  const verb = isRemove ? "removed from" : "applied to";
  const affectedLots = isRemove ? matchedLotCount : modelIds.length;

  if (isSelected && selectedValues.length) {
    return (
      <UpdateInformationWrapper>
        {pronoun} {noun} will be {verb} {affectedLots} {pluralizedModelName}.
      </UpdateInformationWrapper>
    );
  }
}
